import React, { lazy } from "react";
import Form from "../components/Form";
import Documents from "../components/Documents";
import Cal from "../components/Cal";
const Faq = lazy(() => import("../components/Faq"));
const Featuresbenefits = lazy(() => import("../components/Featuresbenefits"));


function Home() {
  return (
    <>
      <Form />
      <Cal/>
      <Featuresbenefits />
      <Documents />
      <Faq />
    </>
  );
}

export default Home;
